export default "__VITE_ASSET__Cdostom7__"